/**
 * HTML input types
 */
export const INPUT_TYPES = {
  TEXT: 'text',
  PASSWORD: 'password',
  EMAIL: 'email',
  TEL: 'tel',
  NUMBER: 'number',
  SEARCH: 'search',
  URL: 'url',
  UUID: 'uuid',
  CODE: 'code',
  CONFIRM_PASSWORD: 'confirmPassword',
} as const;

/**
 * HTML input modes
 */
export const INPUT_MODES = {
  NUMERIC: 'numeric',
  EMAIL: 'email',
  TEL: 'tel',
  TEXT: 'text',
  URL: 'url',
  SEARCH: 'search',
  DECIMAL: 'decimal',
} as const;

/**
 * Input field constraints
 */
export const INPUT_CONSTRAINTS = {
  CODE_LENGTH: 6,
  PASSWORD_MIN_LENGTH: 8,
} as const;

/**
 * Input placeholder text
 */
export const PLACEHOLDERS = {
  PASSWORD_MASK: '********',
} as const;

export const AUTH_ARIA_LABELS = {
  PASSWORD: 'password',
  CONFIRM_PASSWORD: 'confirm password',
  TOGGLE_PASSWORD: 'toggle password visibility',
  TOGGLE_CONFIRM_PASSWORD: 'toggle confirm password visibility',
} as const;

export type InputType = (typeof INPUT_TYPES)[keyof typeof INPUT_TYPES];
export type InputMode = (typeof INPUT_MODES)[keyof typeof INPUT_MODES];
